import { types } from '../actions/types';

const initialState = {
    loading: false,
    data: {},
    error: {},
};

const sendSignedPdfReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case types.SEND_REQUEST_SIGNED_DOCUMENTS:
            return {
                ...state,
                loading: true,
            };
        case types.SEND_REQUEST_SIGNED_DOCUMENTS_SUCCESS:
            return {
                ...state,
                data: payload,
                loading: false,
            };
        case types.SEND_REQUEST_SIGNED_DOCUMENTS_FAILURE:
            return {
                ...state,
                data: {},
                error: payload,
                loading: false,
            };
        case types.CLEAR_REQUEST_SIGNED_DOCUMENTS:
            return {
                ...state,
                data: {},
                loading: false,
            };
        default:
            return state;
    }
};

export default sendSignedPdfReducer